﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

import { applyThemeStyles } from "~base/Styling";
import { createUseStyles } from "react-jss";
import { ConsilioBaseTheme } from "~base/Styling/ConsilioTheme";
import { JssClass } from "~base/Styling";

export interface ConsilioPaginatorStyles {
    controlsContainer?: JssClass;
    limitControls?: JssClass;
    pageControls?: JssClass;
    pageControlsWithoutLimits?: JssClass;
    pageButton?: JssClass;
    pageButtonActive?: JssClass;
    pageButtonEllipsis?: JssClass;
}

export default createUseStyles((theme: ConsilioBaseTheme) => ({
    controlsContainer: applyThemeStyles(
        theme.components.composite.paginator.controlsContainer,
        {
            display: "grid",
            gridTemplateAreas: "'pages limits'",
            gridTemplateColumns: "auto min-content",
            margin: "1rem 0",
        }
    ),
    limitControls: applyThemeStyles(
        theme.components.composite.paginator.limitControls,
        {
            gridArea: "limits",
        }
    ),
    pageControls: applyThemeStyles(
        theme.components.composite.paginator.pageControls,
        {
            gridArea: "pages",
            display: "flex",
            flexDirection: "row",
            alignSelf: "flex-end",
            margin: "0 -0.25rem",
        }
    ),
    pageControlsWithoutLimits: applyThemeStyles(
        theme.components.composite.paginator.pageControlsWithoutLimits,
        {
            justifySelf: "center",
        }
    ),
    pageButton: applyThemeStyles(
        theme.components.composite.paginator.pageButton,
        {
            margin: "0 0.25rem",
            minWidth: "1.15rem",
        }
    ),
    pageButtonActive: applyThemeStyles(
        theme.components.composite.paginator.pageButtonActive,
        {}
    ),
    pageButtonEllipsis: applyThemeStyles(
        theme.components.composite.paginator.pageButtonEllipsis,
        {
            pointerEvents: "none",
        }
    ),
}));
